export const checkStatusType = (status) => {
  let type = '', types = ['', 'primary', 'success'];
  if (status === 9) {
    type = 'warning';
  } else {
    type = types[status];
  }
  return type;
}

export const singleStatusType = (status) => {
  let type = '', types = ['', 'primary', 'success', 'info'];
  if (status === 9) {
    type = 'warning';
  } else {
    type = types[status - 1];
  }
  return type;
}

export const signupStatusType = (status) => {
  let type = '', types = ['', 'primary', 'success', 'info'];
  if (status === 9) {
    type = 'warning';
  } else {
    type = types[status];
  }
  return type;
}

export const touristStatusType = (status) => {
  let type = '', types = ['', 'success', 'danger'];
  if (status === 9) {
    type = types[2];
  } else {
    type = types[status];
  }
  return type;
}

export const feeStatusType = (status) => {
  let type = '';

  if (!status) {
    type = '';
  } else if (status == 1) {
    type = 'primary';
  } else if (status == 2) {
    type = 'success';
  } else if (status == 9) {
    type = 'warning';
  }

  return type;
}


export const rollChangeStatusType = (status) => {
  let type = '';

  if (!status) {
    type = '';
  } else if (status == 1) {
    type = 'primary';
  } else if (status == 2) {
    type = 'info';
  } else if (status == 3) {
    type = 'success';
  } else if (status == 9) {
    type = 'warning';
  }

  return type;
}

export const sealStatusType = (status) => {
  let type = '';

  if (!status) {
    type = '';
  } else if (status == 1) {
    type = 'primary';
  } else if (status == 2) {
    type = 'success';
  } else if (status == 9) {
    type = 'warning';
  }

  return type;
}

export const payoutStatusType = (status) => {
  let type = '';

  if (!status) {
    type = '';
  } else if (status == 1) {
    type = 'primary';
  } else if (status == 2) {
    type = 'success';
  } else if (status == 9) {
    type = 'warning';
  }

  return type;
}

export const pushmoneyStatusType = (status) => {
  let type = '';

  if (!status) {
    type = '';
  } else if (status == 1) {
    type = 'primary';
  } else if (status == 2) {
    type = 'success';
  } else if (status == 9) {
    type = 'warning';
  }

  return type;
}

export const extbillStatusType = (status) => {
  let type = '';

  if (!status) {
    type = '';
  } else if (status == 1) {
    type = 'primary';
  } else if (status == 2) {
    type = 'success';
  } else if (status == 9) {
    type = 'warning';
  }

  return type;
}

export const settleStatusType = (status) => {
  let type = '';

  if (!status) {
    type = '';
  } else if (status == 1) {
    type = 'primary';
  } else if (status == 2) {
    type = 'success';
  } else if (status == 3) {
    type = 'danger';
  } else if (status == 9) {
    type = 'warning';
  }

  return type;
}

export const selltimeType = (status) => {
  let type = '';

  if (!status) {
    type = '';
  } else if (status == 1) {
    type = 'primary';
  } else if (status == 2) {
    type = 'success';
  } else if (status == 3) {
    type = 'danger';
  }

  return type;
}

export const orderStatusType = (status) => {
  let type = '', types = ['', 'primary', 'success', 'info'];
  if (status === 9) {
    type = 'warning';
  } else {
    type = types[status];
  }
  return type;
}

export const companyStatusType = (status) => {
  let type = '', types = ['', 'primary', 'success', 'warning'];
  if (status === -1) {
    type = types[3];
  } else if (status === 9) {
    type = 'danger';
  } else {
    type = types[status];
  }
  return type;
}